function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawImageUpload = function UndrawImageUpload(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 934 618.51",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 405.94,
    y1: 486.08,
    x2: 405.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 882.19,
    y1: 420.35,
    x2: 882.19,
    y2: 420.11,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 678.75,
    y1: 242.6,
    x2: 678.75,
    y2: 70.7,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 811.07,
    y1: 759.23,
    x2: 811.07,
    y2: 366.46,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 784.26,
    y1: 349.97,
    x2: 784.68,
    y2: 349.97,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 784.59,
    y1: 350.3,
    x2: 785,
    y2: 350.3,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 784.59,
    y1: 349.97,
    x2: 785,
    y2: 349.97,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M101 402.52c-22.93 1-47.41 5.77-63.38 22.26-26.62 27.47-15.48 77.4 15.16 100.33s73 23.64 110.08 14.12c19.93-5.12 40.45-12.94 60.49-8.24 25.25 5.92 42.81 30.26 67.84 37.07 33.63 9.19 65.81-15.51 98.21-28.46 55.3-22.13 123.32-7.6 164.76 35.19 11.57 11.94 21.48 26.06 35.93 34.27 14.61 8.31 32.11 9.56 48.91 9.43 50.47-.4 100.16-11.56 149.39-22.66 31.26-7 63.1-14.32 90.74-30.54s50.92-43.14 54.53-75c.63-5.55.61-11.41-1.84-16.44-4.05-8.33-13.52-12.27-22.19-15.52-25.76-9.65-54.71-19.28-80-8.36-6.63 2.87-12.78 7.1-19.86 8.56-20.21 4.15-36.72-14.66-52.46-28-48.72-41.28-119.72-37.51-181.9-52.28C503 361.11 426.12 347.09 350.84 358c-37.88 5.49-67 31.21-103.19 41.15-47.71 13.1-98.09 1.3-146.65 3.37z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M127.8 0V486.08h556.28V0H127.8z"
  }), React.createElement("path", {
    fill: "#535461",
    d: "M131.36 0h549.17v15.55H131.36z"
  }), React.createElement("path", {
    fill: "#ededf4",
    d: "M131.36 15.11h549.17v460.44H131.36z"
  }), React.createElement("circle", {
    cx: 141.58,
    cy: 7.55,
    r: 2.67,
    fill: "#fa595f"
  }), React.createElement("circle", {
    cx: 149.57,
    cy: 7.55,
    r: 2.67,
    fill: "#ffc74c"
  }), React.createElement("circle", {
    cx: 157.57,
    cy: 7.55,
    r: 2.67,
    fill: "#85d459"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M195.34 42.11h421.21V207.4H195.34z"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    d: "M616.55 201.4v6h-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeDasharray: "11.69 11.69",
    d: "M598.86 207.4H207.18"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    d: "M201.34 207.4h-6v-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeDasharray: "11.79 11.79",
    d: "M195.34 189.61V54.01"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    d: "M195.34 48.11v-6h6"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeDasharray: "11.69 11.69",
    d: "M213.03 42.11H604.7"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    d: "M610.55 42.11h6v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeDasharray: "11.79 11.79",
    d: "M616.55 59.9v135.6"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M298.42 230.5h215.05v8.89H298.42zM190.67 313.24h215.05v8.89H190.67zM190.67 332.79h215.05v8.89H190.67zM190.67 352.34h215.05v8.89H190.67zM190.67 371.89h215.05v8.89H190.67zM190.67 391.44h215.05v8.89H190.67zM190.67 410.99h215.05v8.89H190.67zM190.67 430.54h215.05v8.89H190.67zM359.73 248.27h92.42v8.89h-92.42z"
  }), React.createElement("path", {
    d: "M405.94 169.18a44.43 44.43 0 1 0-44.43-44.43 44.42 44.42 0 0 0 44.43 44.43zm0-80.26a35.83 35.83 0 1 1-35.83 35.83 35.82 35.82 0 0 1 35.83-35.83zm3.58 58.76h-7.17a2.16 2.16 0 0 1-2.15-2.15v-20.78h-12a2.15 2.15 0 0 1-1.52-3.67l17.74-17.74a2.15 2.15 0 0 1 3 0l17.74 17.74a2.15 2.15 0 0 1-1.52 3.67h-12v20.78a2.16 2.16 0 0 1-2.11 2.15z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M148.37 353.25c11 40.23-35.93 154.83-35.93 154.83S13.7 433.33 2.7 393.08a75.51 75.51 0 1 1 145.67-39.83z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M148.37 353.25c11 40.23-35.93 154.83-35.93 154.83S13.7 433.33 2.7 393.08a75.51 75.51 0 1 1 145.67-39.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M56 300.6s61.47 92.79 56.83 207.75",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M164.06 426.81s-55.74-30.32-48.68 81.6c0 0 46.5-1.66 63-39.59a32.89 32.89 0 0 0-13.5-41.57z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M165 427s-7.2 58.1-49.59 81.41",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M882.1 420.35c.12-.15.18-.25.18-.25z",
    transform: "translate(-133 -140.75)",
    fill: "url(#prefix__b)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M465.48 70.7v171.9H892.02V70.7H465.48z"
  }), React.createElement("path", {
    d: "M907.72 432.81a21.23 21.23 0 0 0-2-8.89l-12.43-29.75s-.45.62-1.22 1.47c-.91-7.59-4.37-22.07-17.43-23-17.76-1.29-24 7.76-20.42 8.62s18.65 6.9 18.65 6.9l7 11.49c-.13-.09-.25-.18-.38-.28l.26 1.05-.26-.19.26 1.05-.26-.19 6.76 27.9-13.8 12.61s-13.32 6.47-20 6a24 24 0 0 0-3.79.08l.5-.33 4.4-2.92c3.4-2.25 6.95-4.68 8.65-8.32v-.06c.15-.26.29-.53.42-.8 1.79-3.83 1.17-8.24 1.26-12.44a62.84 62.84 0 0 0 .12-7.67 22.12 22.12 0 0 0-2.07-7 25.75 25.75 0 0 0-9.29-11 18.88 18.88 0 0 0-14.17-2.67 9.82 9.82 0 0 1-2.41.42c-1.58 0-2.94-1-4.39-1.61a9.19 9.19 0 0 0-10.54 3c-1 1.32-1.51 2.89-2.52 4.17-1.5 1.91-3.93 3.11-4.94 5.3l-.1.24a5.43 5.43 0 0 0-.35.62c-1 2.16-.34 4.67-.55 7a19 19 0 0 1-2 6 5 5 0 0 0 1.19-.59 20.56 20.56 0 0 0-.29 16.44 36.51 36.51 0 0 1-3.92 12.16l-.13.12h-.06l-.36.28-.4.27q.69-1.07 1.59-2.23c-.88 1.06-5 5.11-13.58.19-9.77-5.6-32.85-5.6-32.85-5.6l-23-10.31c.42-7.26 2.37-35.61 7-37.12a14.21 14.21 0 0 1-1.37.45l.11-.18.11-.16.11-.15.12-.14.11-.12.12-.12.11-.09.13-.1.11-.07.14-.07.18-.08s-.48.19-1.26.41l.41-.68a2 2 0 0 1 .85-.6s-.23.09-.61.22l5.94-9.7s15.09-6 18.65-6.9-2.66-9.92-20.42-8.62c-12 .88-15.9 13.2-17.16 21.08-.05-.13-.11-.25-.16-.39L714.41 433s0 .21.11.58l-.11.28s0 .21.11.58l-.11.28s1.33 9.92 11.1 13.8l36.85 22s16 9.48 16 33.2 3.11 61.22 3.11 61.22.61.36 1.73 1c-2.78 7.75-8.15 21.59-11.95 24-5.33 3.45-18.65 33.2-18.65 33.2h.4l-.39.86h2l-10.87 21.11s-3.55 9.48 0 15.52 2.66 18.54 2.66 18.54 7.1 20.26 12.87 29.75c2.93 4.82 3.46 10.74 3.26 15.41l-12.14 19.94s-5.77 5.17-10.21 4.31c-2.08-.4-4.16 2.22-3.91 4.86V754.57q0 .13.05.27v.09l.06.21v.1l.07.21v.09l.11.25.16.28v.07l.14.21.07.09.14.18.08.09.17.19.07.07.27.25.26.21.1.07.22.15.12.08.24.14.13.07.31.16h.08l.42.18h.12l.34.12.17.05.33.1.18.05.37.09h.17l.57.11.56.08H747.39l.62-.06h.29l.94-.12c18.2-2.59 39.51-12.07 39.51-12.07a35.85 35.85 0 0 0 .15-3.8c.06-5.17-.82-15.45-8.37-18.32h-.39c-1.86-5.74-3.37-13-2.05-19.18 2.66-12.5-7.55-35.34-7.55-43.11 0-1.72-2.22-5.6 2.22-11.21 2.07-2.61 6.83-7.09 11.28-12a20.27 20.27 0 0 1-1.52 2 4 4 0 0 0 .59.12c-.19.24-.38.49-.59.74 0 0 5.91 1.91 10.69-6.53.29-.51.58-1.07.86-1.66 4.88-10.35 17.31-25 23.53-24.14 5.73.79 18.64 11.86 21.31 19.66a9.44 9.44 0 0 1 .44 1.9c.89 7.76 12.43 8.62 12.43 8.62l-.7-.94.44.05a128.53 128.53 0 0 1 6.93 12.1c3.55 7.76 3.11 12.93 3.11 12.93-9.77 19.83-6.22 31.9-6.22 44a53.68 53.68 0 0 1-1 9.77c-6.33 3.91-7.45 21.27-7.45 21.27l.06.07v.79S860 753.29 877.33 755l.81.07H884.95l.29-.06h.22l.28-.06.2-.05.27-.07.18-.05.26-.08.17-.06.25-.09.16-.06.24-.1.14-.06.24-.1.13-.06.23-.11.12-.06.22-.12.1-.06.21-.13.09-.06.2-.14.08-.06.19-.15.07-.05.18-.16.06-.05.18-.17.17-.18.16-.19.15-.2.13-.21.12-.22.11-.23a3.77 3.77 0 0 0 .32-2 3.68 3.68 0 0 0-3.67-4.11c-5.33 0-8-6-8-6l-9.4-22.22-.23-.06c.4-2.19.75-4.32.9-5.76.27-2.67 5.66-15.92 9.72-25.62a60.51 60.51 0 0 0 4.53-18.21 52.08 52.08 0 0 1 1.73-9.62 20.32 20.32 0 0 0-.33-12 45.42 45.42 0 0 1-2.14-10.26c-.47-5.33-2.66-10.72-4.82-14.9h.19l-.29-.94.29.07s-8.88-28.88-13.32-32.76c-3.22-2.81-10.63-16-14.63-24.25a39.71 39.71 0 0 0 2.2-3.34l-.13-.65.13-.21-.13-.65.13-.21s-4.51-22.36-4.68-38.42c.05-5.16.62-9.51 2-12 0 0 1.78-27.16 16-32.33L904 442.46s3.94-2.4 3.75-8.79c-.02-.28-.02-.56-.03-.86zm-100.92 16.4l.4-.61zm31.47 1s-.07.41-.25 1.09a14.46 14.46 0 0 1-1.32-3.14 22.05 22.05 0 0 0 3.43-1.06 5.92 5.92 0 0 0 2.56 1.7 41.63 41.63 0 0 0-4.42 1.42zm8.9 181.61c1 1.49 2 3.08 3 4.7-.95-1.37-2.11-3.11-3-4.69z",
    transform: "translate(-133 -140.75)",
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M467.7 73.31h421.21V238.6H467.7z"
  }), React.createElement("g", {
    opacity: 0.6
  }, React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M846.7 171.57v67.03H512.58V136.94h10.49v-25.9h39.89v25.9h10.85v77.66h13.99v-25.19h16.8v25.19h13.99v-43.03h.7v-22.39h13.3v22.39h30.78v33.59h17.14v-10.5h10.51v10.5h17.14v-99.37h22.39V90.05h3.85v15.74h6.29v31.15h11.2v-25.9h9.44V84.45h19.6v26.59h9.44v25.9h11.55v34.63h15.74v-22.39h13.3v22.39h15.74z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M519.23 144.98h14.69v8.4h-14.69zM566.81 153.37h-14.69v-8.4h14.69zM519.23 161.42h14.69v8.4h-14.69zM566.81 169.82h-14.69v-8.4h14.69zM519.23 177.87h14.69v8.4h-14.69zM566.81 186.26h-14.69v-8.4h14.69zM519.23 194.31h14.69v8.4h-14.69zM566.81 202.71h-14.69v-8.4h14.69zM519.23 210.76h14.69v8.4h-14.69zM566.81 219.16h-14.69v-8.4h14.69zM519.23 227.2h14.69v8.4h-14.69zM566.81 235.59h-14.69v-8.4h14.69zM579.05 223h34.29v4.2h-34.29zM579.05 229.3h34.29v4.2h-34.29zM579.06 235.59h34.28v3h-34.28zM668.62 225.1h34.29v4.2h-34.29zM668.62 231.4h34.29v4.2h-34.29zM668.62 237.7h34.28v.9h-34.28zM625.94 179.62h9.45v12.25h-9.45zM656.02 191.87h-9.45v-12.25h9.45zM625.94 199.21h9.45v12.25h-9.45zM656.02 211.45h-9.45V199.2h9.45zM625.94 218.8h9.45v12.25h-9.45zM656.02 231.05h-9.45V218.8h9.45zM625.93 238.39h9.45v.2h-9.45zM646.58 238.39h9.45v.2h-9.45zM708.16 113.84h12.6v16.09h-12.6zM708.16 136.93h12.6v16.09h-12.6zM708.16 160.02h12.6v16.09h-12.6zM708.16 183.12h12.6v16.09h-12.6zM708.16 206.21h12.6v16.09h-12.6zM708.16 229.3h12.59v9.3h-12.59zM747.87 146.73h46.88v13.64h-46.88zM748.04 176.12h46.88v13.64h-46.88zM748.22 205.51h46.88v13.64h-46.88zM788.02 238.6h7.25v-3.7h-46.88v3.7H788.02zM523.08 118.39h6.3v13.3h-6.3zM830.96 179.62h15.74v20.29h-15.74zM830.96 209.01h15.74v20.29h-15.74zM830.96 238.39h15.75v.2h-15.75z"
  }), React.createElement("path", {
    d: "M605.18 101.13h-2.41a1.69 1.69 0 1 0 0-3.37h-19.5a1.69 1.69 0 1 0 0 3.37h2.41a1.69 1.69 0 1 0 0 3.37h-3.37a1.69 1.69 0 1 0 0 3.37h19.5a1.69 1.69 0 0 0 0-3.37h3.37a1.69 1.69 0 0 0 0-3.37zM691.25 143.47h-2.41a1.69 1.69 0 0 0 0-3.37h-19.5a1.69 1.69 0 0 0 0 3.37h2.41a1.69 1.69 0 1 0 0 3.37h-3.37a1.69 1.69 0 0 0 0 3.37h19.5a1.69 1.69 0 0 0 0-3.37h3.37a1.69 1.69 0 1 0 0-3.37zM837.85 88.19h-2.41a1.69 1.69 0 0 0 0-3.37h-19.5a1.69 1.69 0 1 0 0 3.37h2.41a1.69 1.69 0 1 0 0 3.37H815a1.69 1.69 0 1 0 0 3.37h19.5a1.69 1.69 0 0 0 0-3.37h3.37a1.69 1.69 0 0 0 0-3.37z",
    fill: "#252223",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M784.68 349.82l-.42.31a1.77 1.77 0 0 0 .42-.31z",
    transform: "translate(-133 -140.75)",
    fill: "url(#prefix__e)"
  }), React.createElement("path", {
    d: "M785 350.15l-.42.31a1.77 1.77 0 0 0 .42-.31z",
    transform: "translate(-133 -140.75)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M785 349.82l-.42.31a1.77 1.77 0 0 0 .42-.31z",
    transform: "translate(-133 -140.75)",
    fill: "url(#prefix__g)"
  }), React.createElement("ellipse", {
    cx: 767.29,
    cy: 343.26,
    rx: 0.48,
    ry: 0.64,
    transform: "rotate(-25.74 392.939 563.98)",
    fill: "#f2f2f2"
  })), React.createElement("path", {
    d: "M626.32 477.57l-12.75 25.5s-3.4 9.35 0 15.3 2.55 18.28 2.55 18.28 6.8 20 12.33 29.33 2.13 23 2.13 23l22.1 2.55s-8.5-16.58-6-28.91-7.23-34.84-7.23-42.51c0-1.7-2.13-5.53 2.13-11.05s20.4-19.55 20-27.63zM739 471.62s8.16 11.3 9.11 22.3a46 46 0 0 0 2 10.11 20.6 20.6 0 0 1 .32 11.8 52.73 52.73 0 0 0-1.66 9.49 61.12 61.12 0 0 1-4.34 18c-3.89 9.57-9 22.63-9.3 25.26-.43 4.25-2.55 14.45-2.55 14.45l-17 6.38s5.1-12.33 5.1-24.23-3.4-23.8 6-43.36c0 0 .43-5.1-3-12.75s-16.58-27.63-16.58-27.63z",
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M711.48 486.78c-1.4 1.52 5.81 11.2 5.81 11.2s-11.05-.85-11.9-8.5a9.54 9.54 0 0 0-.43-1.87c-2.56-7.69-14.92-18.6-20.4-19.38-6-.85-17.85 13.6-22.53 23.8-.27.59-.54 1.13-.82 1.64-4.57 8.32-10.23 6.44-10.23 6.44 3-3.7 3.62-6.63 2.68-9-3.72-9.17-31.58-8.9-31.58-8.9s12.75-29.33 17.85-32.73 13.18-28.91 13.18-28.91 60.79-6.8 61.21-3.83 12.33 26.36 16.58 30.18 12.75 32.33 12.75 32.33c-14.45-4.25-30.39 6.16-32.09 7.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M711.48 485.93c-1.4 1.52 5.81 11.2 5.81 11.2s-11.05-.85-11.9-8.5a9.54 9.54 0 0 0-.43-1.87c-2.56-7.69-14.92-18.6-20.4-19.38-6-.85-17.85 13.6-22.53 23.8-.27.59-.54 1.13-.82 1.64-4.57 8.32-10.21 6.43-10.21 6.43 3-3.7 3.62-6.63 2.68-9-3.72-9.17-31.58-8.9-31.58-8.9s12.75-29.33 17.85-32.73 13.18-28.91 13.18-28.91 60.79-6.8 61.21-3.83 12.33 26.36 16.58 30.18 12.75 32.31 12.75 32.31c-14.45-4.25-30.39 6.16-32.09 7.44z",
    fill: "#8499f0"
  }), React.createElement("path", {
    d: "M631.64 581.08l-11.69 19.77s-5.53 5.1-9.78 4.25-8.5 11.9 8.93 9.35 37.83-11.9 37.83-11.9 1.91-17.22-7.86-21zM734.51 574.25l9.14 21.47s2.55 6 7.65 6 6.8 10.63-9.78 8.93-28.91-14.88-28.91-14.88 1.28-20.4 8.93-21.68a32.61 32.61 0 0 1 12.97.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M631.64 581.93l-11.69 19.77s-5.53 5.1-9.78 4.25-8.5 11.9 8.93 9.35 37.83-11.9 37.83-11.9 1.91-17.22-7.86-21zM734.51 575.13l9.14 21.47s2.55 6 7.65 6 6.8 10.63-9.78 8.93-28.91-14.88-28.91-14.88 1.28-20.4 8.93-21.68a32.61 32.61 0 0 1 12.97.16z",
    fill: "#b77983"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M712.19 415.93c.43 3 12.33 26.36 16.58 30.18 3.9 3.51 11.39 27.82 12.59 31.76.77.15 1.53.32 2.29.54 0 0-8.5-28.48-12.75-32.31s-16.15-27.21-16.58-30.18c-.08-.59-2.57-.8-6.48-.74 2.66.07 4.28.28 4.35.75zM682.43 467.37c-6-.85-17.85 13.6-22.53 23.8-.27.59-.54 1.13-.82 1.64-2.64 4.8-5.63 6.2-7.7 6.53 1.37.25 6 .46 9.83-6.53.28-.51.55-1.05.82-1.64 4.29-9.36 14.65-22.28 20.93-23.7zM711.48 485.93l.07-.07c1.37-1 12-8 23.65-8.43-12.45-.43-24.32 7.34-25.78 8.43l-.07.07c-1.23 1.34 4.19 9 5.52 10.8a19.37 19.37 0 0 0 2.41.39s-7.2-9.68-5.8-11.19z"
  })), React.createElement("path", {
    d: "M602.09 255.68s0-25.93 17-27.21 23 7.65 19.55 8.5-17.85 6.8-17.85 6.8l-9.35 15.73zM756 261.63s0-25.93-17-27.21-23 7.65-19.55 8.5 17.85 6.8 17.85 6.8l9.35 15.73zM679 288.41s1.28 17-9.35 26.78 24.69 22.06 24.69 22.06l15.73-18.7s-12.75-7.65-6-20.83z",
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M675.63 308.39s-3.83 6-13.18.43-31.45-5.57-31.45-5.57l-22.1-10.2s1.7-36.56 6.8-38.26c0 0-10.2 4.25-13.18-4.25l-17 45.06s1.28 9.78 10.63 13.6l35.28 21.68s15.3 9.35 15.3 32.73 3 60.36 3 60.36S699 453.76 719 418.91c0 0-8.08-41.23-2.55-51.44 0 0 1.7-26.78 15.3-31.88L767 303.25s6.8-4.25 1.7-16.58l-11.9-29.33s-7.23 10.2-13.18 5.1l6.8 28.91-13.6 12.75s-12.75 6.38-19.13 6-13.6 2.55-13.6 2.55-3 17-16.58 15.3c.02-.01-25.91-1.29-11.88-19.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M675.63 306.69s-3.83 6-13.18.43-31.45-5.54-31.45-5.54l-22.1-10.2s1.7-36.56 6.8-38.26c0 0-10.2 4.25-13.18-4.25l-17 45.06s1.28 9.78 10.63 13.6l35.27 21.72s15.3 9.35 15.3 32.73 3 60.36 3 60.36S699 452.06 719 417.25c0 0-8.08-41.23-2.55-51.44 0 0 1.7-26.78 15.3-31.88L767 301.58s6.8-4.25 1.7-16.58l-11.9-29.33s-7.23 10.2-13.18 5.1l6.8 28.91-13.6 12.75s-12.75 6.38-19.13 6-13.6 2.55-13.6 2.55-3 17-16.58 15.3c.02-.03-25.91-1.32-11.88-19.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M675.61 307.57l-.17.23zM767 302.44l-35.28 32.31c-13.6 5.1-15.3 31.88-15.3 31.88-5.53 10.2 2.55 51.44 2.55 51.44-20 34.86-69.29 5.1-69.29 5.1s-.1-1.22-.26-3.37c-.14-1.88-.33-4.48-.54-7.57-.28-4-.6-8.83-.9-14.07-.67-11.45-1.28-24.79-1.28-35.35 0-23.38-15.3-32.73-15.3-32.73L605 313.8l-8.82-5.42c-9.35-3.83-10.63-13.6-10.63-13.6l17-45.06c2.78 7.94 11.87 4.75 13.05 4.3-5 2.26-6.67 38.21-6.67 38.21l22.1 10.2s22.1 0 31.46 5.53c8 4.7 11.91 1.1 12.91-.09-13.44 18 12.17 19.21 12.17 19.21 13.6 1.7 16.58-15.3 16.58-15.3s7.23-3 13.6-2.55 19.13-6 19.13-6l13.6-12.75-6.8-28.91c6 5.1 13.18-5.1 13.18-5.1l11.9 29.33c5.07 12.38-1.76 16.64-1.76 16.64z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M679 290.11a40.88 40.88 0 0 1-.41 8 20.82 20.82 0 0 0 24 12.53 15 15 0 0 1 1.51-11.16z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 697.95,
    cy: 288.62,
    r: 20.83,
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M697.61 276.77c-.18 2.11-.33 4.36.64 6.24a11.3 11.3 0 0 0 2 2.56l4.36 4.49a11.49 11.49 0 0 1 3.11 4.43c1.26 4.2-2.46 8.37-2.34 12.76a5.68 5.68 0 0 0 6.44 2.38 11 11 0 0 0 2.69-1.49l4.21-2.88c3.25-2.22 6.65-4.62 8.28-8.2 1.71-3.77 1.13-8.13 1.21-12.27a63.79 63.79 0 0 0 .11-7.57 22.3 22.3 0 0 0-2-6.94 25.21 25.21 0 0 0-8.9-10.83 17.65 17.65 0 0 0-13.56-2.63 9.15 9.15 0 0 1-2.3.41c-1.51 0-2.81-1-4.2-1.59a8.64 8.64 0 0 0-10.09 2.91c-.92 1.3-1.45 2.85-2.41 4.11-1.43 1.88-3.76 3.07-4.73 5.22s-.32 4.61-.53 6.93a19.08 19.08 0 0 1-1.89 5.95c2.36-.82 3.51-3.4 5-5.38a13.25 13.25 0 0 1 9.75-4.94c1.3-.06 3.71-.16 4.74.83 1.38 1.25.55 3.98.41 5.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M698 275.92c-.18 2.11-.33 4.36.64 6.24a11.3 11.3 0 0 0 2 2.56l4.36 4.49a11.49 11.49 0 0 1 3.11 4.43c1.26 4.2-2.46 8.37-2.34 12.76a5.68 5.68 0 0 0 6.44 2.38 11 11 0 0 0 2.79-1.53l4.21-2.88c3.25-2.22 6.65-4.62 8.28-8.2 1.71-3.77 1.13-8.13 1.21-12.27a63.79 63.79 0 0 0 .11-7.57 22.3 22.3 0 0 0-2-6.94 25.21 25.21 0 0 0-8.9-10.83 17.65 17.65 0 0 0-13.56-2.63 9.15 9.15 0 0 1-2.3.41c-1.51 0-2.81-1-4.2-1.59a8.64 8.64 0 0 0-10.09 2.91c-.92 1.3-1.45 2.85-2.41 4.11-1.43 1.88-3.76 3.07-4.73 5.22s-.32 4.61-.53 6.93a19.08 19.08 0 0 1-1.89 5.95c2.36-.82 3.51-3.4 5-5.38a13.25 13.25 0 0 1 9.75-4.94c1.3-.06 3.71-.16 4.74.83 1.31 1.29.48 3.99.31 5.54z",
    fill: "#74585e"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M675.46 307.77c.12-.15.18-.24.18-.24zM747.43 263.05a5.47 5.47 0 0 1-3.79-1.42l.41 1.72a6 6 0 0 0 3.38-.3zM672.08 309.98c-10.65 16.35 13.33 17.54 13.33 17.54a13.23 13.23 0 0 0 5.46-.39 14.21 14.21 0 0 1-3.33 0s-25.7-1.27-12.08-19.32a6.92 6.92 0 0 1-3.38 2.17zM715.59 309.66a17.93 17.93 0 0 0 5.11-.61 13.84 13.84 0 0 1-3 .19 27.88 27.88 0 0 0-7.87.79 25 25 0 0 1 5.76-.37zM768.72 285.86l-11.9-29.33a21.73 21.73 0 0 1-1.54 1.87l11.32 27.85c5.1 12.33-1.7 16.58-1.7 16.58l-35.28 32.31c-13.6 5.1-15.3 31.88-15.3 31.88-5.53 10.2 2.55 51.44 2.55 51.44-5.36 9.35-12.83 14-20.9 15.92 8.87-1.51 17.19-6.18 23-16.35 0 0-8.08-41.23-2.55-51.44 0 0 1.7-26.78 15.3-31.88L767 302.44s6.83-4.26 1.72-16.58zM615.7 253.98a15.76 15.76 0 0 1-2.69.77c-4.66 4.09-6.23 37.91-6.23 37.91l22.1 10.2s22.1 0 31.46 5.53c4.58 2.71 7.83 2.66 10 1.91-2 .12-4.57-.41-7.83-2.33-9.35-5.53-31.46-5.53-31.46-5.53l-22.16-10.19s1.7-36.57 6.81-38.27zM612 254.92c-3.23.42-7.67-.05-9.47-5.19l-1 2.65c2.78 3.95 7.87 3.23 10.47 2.54z"
  })), React.createElement("path", {
    d: "M648 398.15c-.67-11.45-1.28-24.79-1.28-35.35 0-23.38-15.3-32.73-15.3-32.73L605 313.8c15.4 4 35.89 10.89 37.73 19 3 13.18 8.5 14.45 6.38 37a254.89 254.89 0 0 0-1.11 28.35zM652 430.6s3.83 11.9-6.8 19.55M711.55 430.6s1.28 8.93 6.38 12.33M656.93 601.69s-20.4 9.35-37.83 11.9c-8.84 1.29-12.1-1.35-12.61-4.15-.58 3.27 2 7.41 12.61 5.85 17.43-2.55 37.83-11.9 37.83-11.9a36 36 0 0 0 .14-4.25c-.07 1.56-.14 2.55-.14 2.55zM741.94 610.62c-16.58-1.7-28.91-14.88-28.91-14.88s.63-10.06 3.65-16.49c-3.39 6.35-4.08 17.34-4.08 17.34s12.33 13.18 28.91 14.88c8.47.87 12.17-1.48 13.08-4-1.39 2.17-5.15 3.92-12.65 3.15z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#fff",
    d: "M505.25 331.9h106.64v71.09H505.25z"
  }), React.createElement("path", {
    d: "M870 512.63s-18.74-63.63 3.51-110.45a100.49 100.49 0 0 0 8.13-63 169 169 0 0 0-8.93-29.59",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M886.6 279.94c0 7.8-14.12 30.41-14.12 30.41s-14.12-22.61-14.12-30.41a14.12 14.12 0 1 1 28.24 0zM909.94 323.14c-4.24 6.55-28.38 17.85-28.38 17.85s.44-26.65 4.68-33.2a14.12 14.12 0 0 1 23.7 15.35zM908.92 396.94c-7 3.51-33.51 1.09-33.51 1.09s13.83-22.79 20.8-26.3a14.12 14.12 0 1 1 12.71 25.21zM895.57 452.62c-6.27 4.64-32.84 6.73-32.84 6.73s9.78-24.8 16.05-29.43a14.12 14.12 0 1 1 16.79 22.7zM851.91 342.5c5.59 5.43 31.65 11.06 31.65 11.06s-6.38-25.88-12-31.32a14.12 14.12 0 0 0-19.68 20.25zM837.13 407.81c7 3.51 33.51 1.09 33.51 1.09s-13.83-22.79-20.8-26.3a14.12 14.12 0 0 0-12.71 25.21zM831.47 473.25c6.27 4.64 32.84 6.73 32.84 6.73s-9.78-24.8-16.05-29.43a14.12 14.12 0 0 0-16.79 22.7z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M801.16 477.47s-11.78-40 2.21-69.44a63.18 63.18 0 0 0 5.11-39.63 106.25 106.25 0 0 0-5.61-18.6",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M811.57 331.19c0 4.9-8.88 19.12-8.88 19.12s-8.88-14.22-8.88-19.12a8.88 8.88 0 0 1 17.75 0zM826.25 358.34c-2.66 4.11-17.84 11.22-17.84 11.22s.28-16.76 2.94-20.87a8.88 8.88 0 1 1 14.9 9.65zM825.6 404.74c-4.38 2.21-21.07.68-21.07.68s8.7-14.33 13.07-16.53a8.88 8.88 0 0 1 8 15.85zM817.21 439.74c-3.94 2.92-20.65 4.23-20.65 4.23s6.15-15.59 10.09-18.5a8.88 8.88 0 0 1 10.56 14.27zM789.77 370.51c3.52 3.42 19.9 7 19.9 7s-4-16.27-7.53-19.69a8.88 8.88 0 1 0-12.37 12.73zM780.47 411.57c4.38 2.21 21.07.68 21.07.68s-8.7-14.33-13.07-16.53a8.88 8.88 0 0 0-8 15.85zM776.92 452.71c3.94 2.92 20.65 4.23 20.65 4.23s-6.15-15.59-10.09-18.5a8.88 8.88 0 1 0-10.56 14.27z",
    fill: primaryColor
  }));
};
UndrawImageUpload.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawImageUpload;